import { Type as T } from '@sinclair/typebox';
import { Value } from '@sinclair/typebox/value';
import { validateField } from '../index.js';

export const CreateMaterialTypeSchema = T.Object({
  name: T.String({ minLength: 1, error: 'Nome do material é um campo obrigatório' }),
  brand: T.String({ format: 'uuid' }),
  multibrandBrands: T.Optional(T.Array(T.String({ format: 'uuid' })), true),
  categoryUuid: T.String({ format: 'uuid', error: 'Uuid do categoria é um campo obrigatório' }),
  observation: T.Optional(T.String()),
  fileType: T.Optional(T.String({ error: 'Imagem é obrigatória' })),
  /** Pre-uploaded image key from image.uploadCompressed endpoint */
  imageKey: T.Optional(T.String()),
});

export type CreateMaterialTypeInputType = typeof CreateMaterialTypeSchema.static;

export async function ValidateCreateMaterialTypeInput(value: unknown): Promise<CreateMaterialTypeInputType> {
  return Value.Parse(CreateMaterialTypeSchema, value);
}

export function checkMaterialTypeCreateInput(field: string, value: unknown): string | boolean {
  return validateField(CreateMaterialTypeSchema, field, value);
}
